$(function () {
	// garder le template
	/*
	let $template = $("#pan-template");

	$(".pan").not("#pan-template").each(function () {
		let $source = $(this);

		// cloner le template
		let $clone = $template.clone().removeAttr("id").show();

		// remplir avec les data
		$clone.find(".pan-title").text($source.data("title"));
		$clone.find(".rescount").text($source.data("rescount"));
		$clone.find(".seeall").attr("href", $source.data("href"));

		// mettre le contenu
		$clone.find(".pan-content").append($source.contents());

		// remplacer l’ancien .pan par le clone
		$source.replaceWith($clone);
	});
	*/
});
